import { isSubscriptionUsed } from '../data-selectors/blocks/common';
import { checkStoreAuthRequired } from '../data-selectors/blocks/store';
import { AbstractBlock } from '../types/blocks';
import {
  Authorization,
  LandingTypes,
  AuthorizationTypes,
} from '../types/model/landing';
import { StoreItem } from '../types/store';

export const isUserAccountShown = (auth: Authorization) =>
  auth.type === AuthorizationTypes.USER_ID ||
  (auth.type === AuthorizationTypes.LOGIN && auth.loginId);

export const isLoginSettingsError = (
  auth: Authorization,
  landingType: LandingTypes,
  blocks: AbstractBlock[],
  bundles: StoreItem[]
) => {
  const isLoginError =
    auth.loginId === '' &&
    (blocks.some(isSubscriptionUsed) ||
      checkStoreAuthRequired(blocks, bundles, landingType));
  const isUserError =
    (auth.requiredWebhook && auth.webhookUrl === '') || !auth.userIdLoginId;
  return auth.type === 'login' ? isLoginError : isUserError;
};
